import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2c-6 0-8 2-8 8v4c0 6 2 8 8 8h3c5.105 0 7.314-1.448 7.86-5.574L22.04 18H24V6h-1.96l-3.18 1.574C18.314 3.448 16.105 2 11 2z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VideocameraFilledSize24Glyph.displayName = 'VideocameraFilledSize24Glyph';
